import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_spqpp3hgqu: FaireBrandEntity = {
  token: "b_spqpp3hgqu",
  type: "brand",
  name: "Southern Backroad Tees LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/dc8c7992fa78610532c7ded26d6481dc49a6797230ac9ab8c825219430bfff65.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d86df8be5630059bc7d9b0c424a37d7d5cb953e108dd6f89c3418c1735e0350f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dc8c7992fa78610532c7ded26d6481dc49a6797230ac9ab8c825219430bfff65.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d86df8be5630059bc7d9b0c424a37d7d5cb953e108dd6f89c3418c1735e0350f.jpeg",
  location: "Olive Branch , MS, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 232,
  isInsider: true,
  description:
    "Hello and Welcome to Southern Backroad Tees LLC. I am excited to help you bring the newest tumblers, tees, and sweatshirts to your boutique. We have been doing retail sales for over 3 years now but recently decided to grow our business further and add wholesale to our shop. We currently sale our products locally in a boutique/market here in Byhalia, MS. We can fulfill all of your wholesale needs, no matter how big or small. We offer sublimation and DTF. If you would like to see more of our products, please visit our website or join our Facebook wholesale group, Southern Backroad Tees Wholesale. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:28.232Z",
    importedBy: "entity-db-cli",
  },
};
